import useCollection from "areas/collection/hoc/use-collection"
import { IS_JEWLR } from "helpers/application"
import { cn } from "styles/utils"

import Breadcrumb from "./breadcrumb"
import Description from "./description"
import Title from "./title"

const Heading = () => {
  const { data: { pagination: { total_product_count } = {} } = {} } =
    useCollection()

  return (
    <div className="desktop:pt-16 mb-14 mt-16">
      <div
        className={cn(
          "flex items-start",
          IS_JEWLR() ? "justify-between" : "justify-end"
        )}
      >
        {IS_JEWLR() && <Breadcrumb />}
        <div aria-atomic aria-live="polite">
          <span className="text-14 text-grey-500">
            {total_product_count} Products
          </span>
        </div>
      </div>
      <div className="mt-16 flex items-start justify-between">
        <div className="desktop:w-3/4">
          <Title />
          <Description />
        </div>
      </div>
    </div>
  )
}
export default Heading
